/* eslint-disable max-classes-per-file */
import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';
import { IWorkScheduleTemplate } from '../../models/work-schedule-template.model';

export class LoadWorkScheduleTemplates {
  static readonly type = '[Work Schedule Template] Load work schedule templates via Service';
  constructor(public filter?: MainTableFilterModel) {}
}

export class LoadAllWorkScheduleTemplates {
  static readonly type = '[Work Schedule Template] Load all work schedule templates via Service';
  constructor(public filter?: MainTableFilterModel) {}
}

export class LoadWorkScheduleTemplateById {
  static readonly type = '[Work Schedule Template] Load a single work schedule template';
  constructor(public id: string) {}
}

export class CreateWorkScheduleTemplate {
  static readonly type = '[Work Schedule Template] Create work schedule template';
  constructor(public workScheduleTemplate: IWorkScheduleTemplate) {}
}

export class UpdateWorkScheduleTemplate {
  static readonly type = '[Work Schedule Template] Update work schedule template';
  constructor(public workScheduleTemplate: IWorkScheduleTemplate) {}
}

export class DeleteWorkScheduleTemplate {
  static readonly type = '[Work Schedule Template] Delete work schedule template';
  constructor(public id: string) {}
}

export class ClearCurrentWorkScheduleTemplate {
  static readonly type = '[Work Schedule Template] Clear current work schedule template';
}
